import { useQuery } from "@tanstack/react-query";

import { getClients } from "../services/clientService";

const useClients = () => useQuery({
    queryKey: ['clients'],
    queryFn: () => getClients().then(res => res.data),
    staleTime: 60 * 60 * 1000  // 1 hour
})

export default useClients;